import React from "react";
import { Button, Form } from "antd";

function ButtonPicker({
  form,
  hide_submit,
  formName,
  submitBtnId,
  submitButtonText,
  cancelButtonText,
  marginLeft,
  disabled,
  children,
  loading,
  noSubmit,
  onClick,
  width,
  type,
  onCancel,
  resetButton
}) {

  const cancel = () => {
    form.resetFields();
    if (onCancel) {
      onCancel();
    }
  }

  return (
    <Form.Item
      className="formBtnGroup"
      colon={false}
      style={{
        marginTop: "0px",
        marginLeft: marginLeft ? marginLeft : 0,
        display: "flex",
        justifyContent: "center",
        marginBottom: 0,
        textAlign: "center",
      }}
    >
      {cancelButtonText ? (
        <Button
          size="large"
          onClick={cancel}
          danger
          type="primary"
          style={{
            fontWeight: 600,
            borderRadius: "10px",
            width: width ? width : "",
          }}
        // className="login-form-button gx-mt-1 bigBtn"
        >
          {cancelButtonText}
        </Button>
      ) : (
        <></>
      )}
      {
        !hide_submit && (
          <Button
            size="large"
            id={submitBtnId || "submitButtonForm"}
            style={{
              marginLeft: "30px",
              fontWeight: 600,
              borderRadius: "10px",
              width: width ? width : "",
              // marginBottom: 0,
            }}
            disabled={disabled}
            loading={loading ? loading : false}
            type={type ? type : "primary"}
            form={formName}
            htmlType={noSubmit ? "button" : "submit"}
            onClick={onClick ? onClick : () => { }}
          >
            {submitButtonText}
          </Button>
        )
      }

      {children}
    </Form.Item>
  );
}

export default ButtonPicker;
